import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { downloadFromApi } from '~/helpers/files/download-from-api'

/** Route du relevé d'assiduité (#322) : celui d'un apprenant, sinon ceux de tous les inscrits. */
export function attendanceStatementPath(sessionId: string, userId?: string): string {
  const query = new URLSearchParams({ sessionId, ...(userId && { userId }) })
  return `/attendance/statement?${query.toString()}`
}

/**
 * Téléchargement des relevés d'assiduité d'un apprenant (#322), parcours par
 * parcours depuis sa fiche : l'identifiant en cours dit quelle ligne patiente.
 */
export function useAttendanceDownload(userId: string) {
  const { t } = useTranslation()
  const [downloadingId, setDownloadingId] = useState<string | null>(null)

  const download = async (sessionId: string) => {
    setDownloadingId(sessionId)
    try {
      await downloadFromApi(attendanceStatementPath(sessionId, userId), 'releve-assiduite.pdf')
    } catch {
      toast.error(t('attendance.failed'))
    } finally {
      setDownloadingId(null)
    }
  }

  return { download, downloadingId }
}
